import CommonModal from "@/components/ui/CommonModal";
import { useModalBehavior } from "@/hooks/behaviors";
import { toBase64 } from "@/utils/encode";
import { forwardRef, useImperativeHandle, useState } from "react";

export type DocumentPreviewerRef = {
  openFilePreview: (url: string) => void;
};

const previewService = "http://10.4.100.111:8012/onlinePreview?url=";
export const DocumentPreviewer = forwardRef<DocumentPreviewerRef, {}>(
  (_, ref) => {
    const { open, openModal, closeModal } = useModalBehavior();
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    useImperativeHandle(ref, () => {
      return {
        openFilePreview: (url) => {
          setFileUrl(previewService + encodeURIComponent(toBase64(url)));
          openModal();
        },
      };
    });

    if (!fileUrl) return null;

    return (
      <CommonModal
        width={900}
        title="文件预览"
        open={open}
        style={{
          top: 10,
        }}
        onCancel={() => {
          closeModal();
          setFileUrl(null);
        }}
        footer={null}
      >
        <div style={{ height: "75vh" }}>
          <iframe
            id="inlineFrame"
            title="文件预览"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            src={fileUrl}
          ></iframe>
        </div>
      </CommonModal>
    );
  },
);
